// Action Types
const ADD_PRODUCT_DISCLAIMER = 'productDisclaimers/addProductDisclaimer';

// Action Creators
export function addProductDisclaimer(payload: { productId: string; productDisclaimer: string }) {
  return {
    type: ADD_PRODUCT_DISCLAIMER,
    payload,
  };
}

// State
interface ProductDisclaimersState {
  disclaimers: Record<string, string>;
}

const initialState: ProductDisclaimersState = {
  disclaimers: {},
};

// Reducer
export default function productDisclaimersReducer(state = initialState, action: any): ProductDisclaimersState {
  switch (action.type) {
    case ADD_PRODUCT_DISCLAIMER: {
      const { productId, productDisclaimer } = action.payload;
      // Only update if the disclaimer for this product ID doesn't already exist
      if (!state.disclaimers[productId]) {
        return {
          ...state,
          disclaimers: {
            ...state.disclaimers,
            [productId]: productDisclaimer,
          },
        };
      }
      return state;
    }
    default:
      return state;
  }
}
